import { useEssentials } from 'hooks/utils/useEssentials'
import { isStore } from 'utils/location'
import { TheftStore } from './theft-store'
import { TheftRGD } from './theft-rgd'

export const Theft = () => {
    const { currentLocation } = useEssentials()
    const isStoreLocation = isStore(currentLocation)

    return isStoreLocation ? <TheftStore /> : <TheftRGD />
}
